import React, { useState, useEffect } from "react";
import axiosInstance from '../../../axiosInstance';
import { Container, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-phone-number-input/style.css";
import { isValidPhoneNumber } from "react-phone-number-input";
import Modal from 'apollo-react/components/Modal';

import { Formik, Form, Field } from "formik";
import Button from "../../common/Button";
import Grid from "apollo-react/components/Grid";
import SwitchInput from "../../common/Form/switchInput";
import { renderInputComponent } from "../../common/Form/renderInputComponent";
import PhoneInput from "../../common/Form/PhoneInput";

const DynamicForm = ({ persona }) => {
	const [formFields, setFormFields] = useState([]);
	const [formData, setFormData] = useState({});
	const [formDataCopy, setFormDataCopy] = useState({});
	const [roles, setRoles] = useState([]);
	const [isUpdate, setIsUpdate] = useState(false);
	const [loading, setLoading] = useState(true);
	const [resp, setResp] = useState("");
	const [token, setToken] = useState("");
	const [phone, setPhone] = useState();
	const [error, setError] = useState("");
	const [initialValues, setInitialValues] = useState({});
	const [discardModal, setDiscardModal] = useState(false);

	const [t] = useTranslation();
	const { id } = useParams();
	let navigate = useNavigate();

	// const basePath = persona === "super-admin" ? "/super-admin" : "/admin";

	// Fetch form fields and data (if updating) from the backend
	useEffect(() => {
		const fetchFormMetadata = async () => {
			try {
				const response = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/users/form-fields`, { withCredentials: true })
					.catch((err) => console.log(err));

				setFormFields(response.data);

				// Get Roles
				const roles = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/roles`, { withCredentials: true })
					.catch((err) => console.log(err));

				const filteredRoles = roles.data.filter(
					(role) => role.active === true && role.published === true
				);

				setRoles(filteredRoles);

				if (id) {
					// If we have an ID, fetch data for updating
					setIsUpdate(true);

					const { data: recordData } = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/users/${id}`, { withCredentials: true })
					.catch((err) => console.log(err));

					const phone = recordData.phone;
					setPhone(phone);
					setFormData(recordData);
					setFormDataCopy(recordData);
				}

				setLoading(false);
			} catch (err) {
				setResp(t("Error fetching form metadata or data"));
				console.error(t("Error fetching form metadata or data: "), err);
				setLoading(false);
			}
		};

		fetchFormMetadata();
	}, [id, t, axiosInstance]);

	useEffect(() => {
		const initialValues = formFields.reduce((acc, field) => {
			acc[field.name] = formData[field.name] || "";
			return acc;
		}, {});

		setInitialValues(initialValues);
	}, [formFields, formData]);

	// Handle input changes
	const handleChange = (name, value) => {
		setFormData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	// // Handle input changes
	// const handleInputChange = (event) => {
	//   const { name, value, type, checked } = event.target;
	//   const s = type === "checkbox" ? (checked ? 1 : 0) : value;
	//   setFormData({
	//     ...formData,
	//     [name]: type === "checkbox" ? s : value,
	//   });
	// };


	const validateEmail = (email) => {
	 // Regular expression to validate email format
	 const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	 return emailRegex.test(email);
	}
	

	const validate = () => {
		let errorMessage = "";
		if(!formData.username)
		{
			errorMessage = t("Username is required!");

		} else if(!formData.email)
		{
			errorMessage = t("Email is required!");

		} else if(!formData.password && !isUpdate)
		{
			errorMessage = t("Password is required!");
	
		} else if(!formData.role_id)
		{
			errorMessage = t("Role is required!");
		
		} else if(!formData.phone)
		{
			errorMessage = t("Phone is required!");
	
		}

		if(formData.email)
		{
			if(!validateEmail(formData.email))
			{
				errorMessage = t("Invalid email format!");
			}
		}
		console.log('formdataaa', formData, errorMessage, errorMessage ? false : true)

		if(errorMessage)
			toast.error(errorMessage, { position: "top-center" });

		return errorMessage ? false : true;
	}

	// Handle form submission (Add or Update)
	const handleSubmit = async (e) => {
		try {
			const isValid = validate();
			if(!isValid)
				return;

			if (isUpdate) {
				if (!formData.password) delete formData.password;
				axiosInstance
					.put(`/api/users/${id}`, formData)
					.then((resp) => {
						toast.success("User Updated Successfully!", {
							position: "top-center",
						});
						navigate(-1);
					})
					.catch((error) => {
						setResp(t("Error updating form"), ":", error);
					});
			} else {
				axiosInstance
					.post("/api/users/", formData)
					.then((resp) => {
						toast.success(t("User Added Successfully!"), {
							position: "top-center",
						});
						setToken("");
						if (resp.data.token) {
							setToken(resp.data.token);
						} else {
							navigate(-1);
						}
					})
					.catch((error) => {
						setResp(t("Error creating form"), ":", error);
					});
			}
		} catch (err) {
			setResp(t("Error submitting form"), ":", err);
			console.error("Error submitting form: ", err);
		}
	};

	if (loading) return <div>Loading...</div>;

	const handlePhoneChange = (phone) => {
		setPhone(phone);
		setFormData({
			...formData,
			phone: phone,
		});
		if (phone && !isValidPhoneNumber(phone)) {
			setError("Invalid phone number");
		} else {
			setError("");
		}
	};

	return (
		<div
			className="content"
			style={{
				border: "solid 1px #E9E9E9",
				padding: "24px",
				borderRadius: "5px",
			}}
		>
			{resp && <p>{resp}</p>}
			<Grid container justifyContent={"center"}>
				<Grid item md={12}>
					<Formik
						initialValues={initialValues}
						enableReinitialize={true}
						onSubmit={handleSubmit}
					>
						{({ handleSubmit, setFieldValue }) => (
							<Form onSubmit={handleSubmit}>
								<Grid container spacing={2}>
									{formFields.map((field, index) => (
										<React.Fragment key={field.name}>
											{/* Start a new row for every two inputs */}
											{index % 2 === 0 && <Grid container spacing={2}></Grid>}
											<Grid item xs={6}>
												<Field key={field.name} name={field.name}>
													{({ field: formikField, meta }) => {
														const handleFieldChange = (value) => {
															console.log("formikField", formikField, value);
															setFieldValue(formikField.name, value);
															handleChange(formikField.name, value);
														};
														if (field.type === "dropdown") {															
															field.options = roles.map((role) => ({
																key: role.id,
																label: role.name,
															}));
														}
														return renderInputComponent(
															field,
															formData,
															formikField,
															meta,
															handleFieldChange
														);
													}}
												</Field>
											</Grid>
										</React.Fragment>
									))}
								</Grid>
								{/* {isUpdate ? (
									<Form.Group
										className="mb-3"
										controlId="exampleForm.ControlInput3"
									>
										<Form.Check
											name={"blocked"}
											onChange={handleInputChange}
											type="switch"
											label={t("Blocked")}
											checked={formData["blocked"]}
											value={formData["blocked"]}
										/>
									</Form.Group>
								) : null} */}
								{isUpdate ? (
									<>
										<div className="mb-2">
											<Link
												to={`/${persona}/user/privilegis/${id}`}
												className="text-decoration-none"
											>
												Set Specific Priviliges
											</Link>
										</div>
										<Field name={"active"}>
											{({ field: formikField, meta }) => (
												<SwitchInput
													{...formikField}
													meta={meta}
													name={"active"}
													onChange={(checked) =>
														handleChange("active", checked)
													}
													label={"Active"}
													checked={formData["active"]}
													value={formData["active"]}
													style={{ marginTop: "16px", marginBottom: "8px" }}
												/>
											)}
										</Field>
									</>
								) : null}
								<Field key="phone" name="phone">
									{({ field: formikField, meta }) => (
										<PhoneInput
											{...formikField}
											meta={meta}
											label="Phone Number"
											value={formData["phone"] || "+20"}
											onChange={(value)=>handleChange("phone", value)}
											error={error}
										/>
									)}
								</Field>

								{/* {error && <div style={{ color: "red" }}>{error}</div>} */}

								<div style={{display: 'flex', justifyContent: 'flex-end', marginTop: '50px'}}>
								<Button
								color="primary"
          						onClick={() => setDiscardModal(true)}
								style={{
									padding: "12px 22px",
									width: "157px",
            						height: '40px',
            						marginRight: '24px',
								}}
          						text={t("Discard")}
								/>

								<Button
									color="primary"
									type="submit"
									style={{padding:"12px 22px", width:"157px", height:"40px" }}
									text={t("Save")}
								/>
								</div>
							</Form>
						)}
					</Formik>{" "}
					{token && (
						<div className="mt-2 p-2 card">
							<h6>Generated Token:</h6>
							<p className="">{token}</p>
						</div>
					)}
				</Grid>
			</Grid>

			<Modal
			open={discardModal}
			message="Are you sure you want to discard your changes?"
			buttonProps={[{onClick: () => {
				setDiscardModal(false);
				}},
				{ label: 'Confirm', onClick: () => {
					setFormData(formDataCopy);
					setDiscardModal(false);
				} }]}
			hideHeader
			id="hideHeader"
			/>
		</div>
	);
};

export default DynamicForm;
